/**
 * Configuration API Centralisée - Leu Budget du Génie
 * 
 * Ce fichier centralise la configuration du backend.
 * REACT_APP_BACKEND_URL est géré automatiquement par la plateforme Emergent.
 * 
 * Version: 4.1.0
 * Date: Avril 2026
 */

// URL du backend - Gérée par la plateforme Emergent
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Validation stricte - La plateforme doit fournir cette variable
if (!BACKEND_URL) {
  console.error('[CONFIG] ERREUR CRITIQUE: REACT_APP_BACKEND_URL non définie par la plateforme');
}

// Log de la configuration au démarrage (pour debug)
if (process.env.NODE_ENV === 'development') {
  console.log('[CONFIG] Backend URL:', BACKEND_URL);
}

// Export de l'URL validée
export const API_URL = BACKEND_URL;

// Helper pour les appels API avec gestion d'erreur
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;
  
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
    return response;
  } catch (error) {
    console.error(`[API] Erreur appel ${endpoint}:`, error);
    throw error;
  }
};

// Export par défaut
export default API_URL;
